import revaActions from "../reducers/revaReducer/revaActions";
import revaService from "../reducers/revaReducer/RevaService";
import playerService from "../reducers/playerReducer/playerService";
import lineupService from "../reducers/lineupReducer/lineupService";
import { setLoading } from "../reducers/loadingReducer";
import handler from "../../utils/functions/handler";
import { actions as alertActions } from "../reducers/alertReducer";

export const loadRevaMe = () => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadMe"));
  const [error, me] = await revaService.getMe(apiKey);
  dispatch(setLoading.false("reva.loadMe"));

  if (error) {
    if (error?.response?.status === 401 || (error?.response?.status === 500 && error?.response?.data?.message === "Unauthenticated.")) {
        dispatch(revaActions.setRevaConnectionError(true));
        return [error, null];
    }
    return dispatch(handler(error));
  }
  
  dispatch(revaActions.setRevaConnectionError(false));
  dispatch(revaActions.setRevaMe(me));
  return [null, me];
};

export const validateRevaApiKey = (apiKey) => async (dispatch) => {
    dispatch(setLoading.true("reva.validateKey"));
    const [error, me] = await revaService.getMe(apiKey);
    dispatch(setLoading.false("reva.validateKey"));
    
    if (error) {
        if (error?.response?.status === 401 || (error?.response?.status === 500 && error?.response?.data?.message === "Unauthenticated.")) {
            dispatch(revaActions.setRevaConnectionError(true));
        }
        dispatch(handler(error));
        return [error, null];
    }
    
    dispatch(revaActions.setRevaConnectionError(false));
    return [null, me];
};

export const loadRevaAccounts = () => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadAccounts"));
  const [error, accounts] = await revaService.getAccounts(apiKey);
  dispatch(setLoading.false("reva.loadAccounts"));

  if (error) return dispatch(handler(error));
  const normalizedAccounts = Array.isArray(accounts) ? accounts : (accounts?.data || accounts?.results || []);
  dispatch(revaActions.setRevaAccounts(normalizedAccounts));
};

export const loadRevaLineups = () => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadLineups"));
  const [error, lineups] = await revaService.getLineups(apiKey);
  dispatch(setLoading.false("reva.loadLineups"));

  if (error) return dispatch(handler(error));
  const normalizedLineups = Array.isArray(lineups) ? lineups : (lineups?.data || lineups?.results || []);
  dispatch(revaActions.setRevaLineups(normalizedLineups));
};

export const syncLineupWithReva = (lineupData) => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  console.log("lineupData", lineupData);
  dispatch(setLoading.true("reva.syncLineup"));
  const mappedData = {
      external_entity_id: lineupData.id,
      name: lineupData.name || lineupData.team?.name,
      external_relationship_id: lineupData.external_relationship_id,
      external_display_name: lineupData.external_display_name,
      contact_info: {
          email: lineupData.email || organizer.single.email || "contacto@fansbury.com",
          phone: lineupData.phone || organizer.single.phone || organizer.single.phoneNumber || "+595981000111"
      }
  };

  const [error, syncedLineup] = await revaService.syncLineup(apiKey, mappedData);
  dispatch(setLoading.false("reva.syncLineup"));

  if (error) return dispatch(handler(error));

  dispatch(revaActions.updateRevaLineup(syncedLineup));
  dispatch(
    alertActions.showFloatingAlert(
      `Planilla <b>${syncedLineup.name}</b> sincronizada con éxito.`,
      "info",
      3500
    )
  );
  
  dispatch(loadRevaAccounts());
  dispatch(loadRevaLineups());
  
  // Auto-apply 'Inscripción' (tournament-entry-fee) charge immediately after lineup sync
  if (lineupData.external_relationship_id) {
      await dispatch(applyAutomatedCharge(lineupData.external_relationship_id, lineupData.id, 'tournament-entry-fee'));
  }

  dispatch(loadLineupFinancials(lineupData.id));
  dispatch(loadDebtSummary());
  dispatch(loadSiloBalances());
};

export const loadLineupFinancials = (lineupId) => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadFinancials"));
  const [errorBalance, balance] = await revaService.getLineupBalance(apiKey, lineupId);
  const [errorTransactions, transactions] = await revaService.getLineupTransactions(apiKey, lineupId);
  dispatch(setLoading.false("reva.loadFinancials"));

  if (errorBalance || errorTransactions) {
      return dispatch(handler(errorBalance || errorTransactions));
  }

  const normalizedBalance = balance?.data || balance || { available: 0, pending: 0 };
  const normalizedTransactions = Array.isArray(transactions) ? transactions : (transactions?.data || transactions?.results || []);

  dispatch(revaActions.setRevaLineupFinancials({ 
    balance: normalizedBalance, 
    transactions: normalizedTransactions 
  }));

  dispatch(loadLineupInvoices(lineupId));
  dispatch(loadSiloBalances({ external_entity_id: lineupId }));
};

export const loadSiloBalances = (params = {}) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.loadSiloBalances"));
    const [error, balances] = await revaService.getSiloBalances(apiKey, params);
    dispatch(setLoading.false("reva.loadSiloBalances"));

    if (error) return dispatch(handler(error));
    
    const balancesData = Array.isArray(balances) ? balances : (balances?.data || []);
    const normalizedBalances = balancesData.map(acc => {
        const typeStr = String(acc.target_type || acc.accountable_type || acc.type || '').toLowerCase();
        return {
            ...acc,
            type: (typeStr.includes('individual') || typeStr.includes('user') || typeStr === 'player') ? 'user' : 'entity'
        };
    });
    
    if (params.external_entity_id) {
        dispatch(revaActions.setRevaLineupSiloBalances(normalizedBalances));
    } else {
        dispatch(revaActions.setRevaSiloBalances(normalizedBalances));
    }
};

export const loadDebtSummary = () => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadDebtSummary"));
  const [error, summary] = await revaService.getDebtSummary(apiKey);
  dispatch(setLoading.false("reva.loadDebtSummary"));

  if (error) return dispatch(handler(error));
  dispatch(revaActions.setRevaDebtSummary(summary));
};

export const loadIncomeSummary = () => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.loadIncomeSummary"));
    const [error, summary] = await revaService.getIncomeSummary(apiKey);
    dispatch(setLoading.false("reva.loadIncomeSummary"));

    if (error) return dispatch(handler(error));
    dispatch(revaActions.setRevaIncomeSummary(summary));
};

export const loadTransactionsSummary = () => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.loadTransactionsSummary"));
    const [error, summary] = await revaService.getTransactionsSummary(apiKey);
    dispatch(setLoading.false("reva.loadTransactionsSummary"));

    if (error) return dispatch(handler(error));
    dispatch(revaActions.setRevaTransactionsSummary(summary));
};

export const loadLineupInvoices = (lineupId) => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  dispatch(setLoading.true("reva.loadInvoices"));
  const [error, invoices] = await revaService.getInvoices(apiKey, lineupId);
  dispatch(setLoading.false("reva.loadInvoices"));

  if (error) return dispatch(handler(error));
  const normalizedInvoices = Array.isArray(invoices) ? invoices : (invoices?.data || invoices?.results || []);
  dispatch(revaActions.setRevaLineupInvoices(normalizedInvoices));
};

export const registerInvoicesPayment = (lineupId, data) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.registerPayment"));
    const [error, result] = await revaService.registerInvoicesPayment(apiKey, lineupId, data);
    dispatch(setLoading.false("reva.registerPayment"));

    if (error) return dispatch(handler(error));
    
    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary()); // Refresh global summary
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances()); // Refresh lineups card
    dispatch(alertActions.showFloatingAlert("Pago registrado con éxito.", "info", 3000));
};

export const registerAddBalance = (lineupId, data) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.registerBalance"));
    const [error, result] = await revaService.registerAddBalance(apiKey, lineupId, data);
    dispatch(setLoading.false("reva.registerBalance"));

    if (error) return dispatch(handler(error));
    
    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary()); // Refresh global summary
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances()); // Refresh lineups card
    dispatch(alertActions.showFloatingAlert("Saldo cargado con éxito.", "info", 3000));
};

export const registerPlayerAddBalance = (lineupId, playerId, data) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.registerPlayerBalance"));
    const [error, result] = await revaService.registerPlayerAddBalance(apiKey, lineupId, playerId, data);
    dispatch(setLoading.false("reva.registerPlayerBalance"));

    if (error) return dispatch(handler(error));
    
    dispatch(loadPlayerFinancials(lineupId, playerId));
    dispatch(loadDebtSummary()); // Refresh global summary
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances()); // Refresh lineups card
    dispatch(alertActions.showFloatingAlert("Saldo de jugador cargado con éxito.", "info", 3000));
};

// Player (Individual) Thunks
// playerData should include: { id, name, email, lineupName }
export const syncPlayerWithReva = (lineupId, playerData) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.syncPlayer"));
    const mappedData = {
        player_id: playerData.id,
        player_name: playerData.name || playerData.fullName,
        external_display_name: playerData.lineupName || "Lineup",
        contact_info: {
            email: playerData.email || organizer.single.email || "contacto@fansbury.com"
        }
    };

    const [error, syncedPlayer] = await revaService.syncPlayer(apiKey, lineupId, mappedData);
    dispatch(setLoading.false("reva.syncPlayer"));

    if (error) return dispatch(handler(error));
    dispatch(alertActions.showFloatingAlert(`Jugador sincronizado con éxito.`, "info", 3000));
    dispatch(loadRevaAccounts());
    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    return [null, syncedPlayer];
};

export const loadPlayerFinancials = (lineupId, playerId) => async (dispatch, getState) => {
    const { organizer, player } = getState();
    console.log('lineup id', lineupId, 'player id', playerId, 'organizer', organizer);

    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;
    dispatch(setLoading.true("reva.loadPlayerFinancials"));
    let [errorBalance, balance] = await revaService.getPlayerBalance(apiKey, lineupId, playerId);
    let [errorInvoices, invoices] = await revaService.getPlayerInvoices(apiKey, lineupId, playerId);
    
    // Lazy sync if account not found (404 / error)
    if (errorBalance) {
        const playerData = player.all.find(p => p.id === playerId);
        if (playerData) {
            // Derive lineup name from state (acceptable here since user is on a lineup view)
            const targetLineup = (getState().lineup.all || []).find(l => l.id === lineupId);
            const lineupName = targetLineup?.team?.name || targetLineup?.name || "Lineup";

            // Silently sync
            const [syncError] = await revaService.syncPlayer(apiKey, lineupId, {
                player_id: playerData.id,
                player_name: `${playerData.firstName} ${playerData.lastName}`.trim(),
                external_display_name: lineupName,
                contact_info: {
                    email: playerData.email || organizer.single.email || "contacto@fansbury.com"
                }
            });
            
            if (!syncError) {
                // Retry fetching financials
                [errorBalance, balance] = await revaService.getPlayerBalance(apiKey, lineupId, playerId);
                [errorInvoices, invoices] = await revaService.getPlayerInvoices(apiKey, lineupId, playerId);
                
                // Refresh accounts / silo balances quietly so UI updates
                dispatch(loadRevaAccounts());
                dispatch(loadSiloBalances());
            }
        }
    }

    dispatch(setLoading.false("reva.loadPlayerFinancials"));

    if (errorBalance || errorInvoices) {
        return dispatch(handler(errorBalance || errorInvoices));
    }

    const normalizedBalance = balance?.data || balance || { available: 0, pending: 0 };
    const normalizedInvoices = Array.isArray(invoices) ? invoices : (invoices?.data || invoices?.results || []);

    dispatch(revaActions.setRevaLineupFinancials({ 
        balance: normalizedBalance, 
        transactions: [] // Transactions endpoint for individuals not yet in service, but we use invoices
    }));
    dispatch(revaActions.setRevaLineupInvoices(normalizedInvoices));
    dispatch(loadSiloBalances({ external_entity_id: lineupId }));
};

export const loadPlayerInvoices = (lineupId, playerId) => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  const [error, invoices] = await revaService.getPlayerInvoices(apiKey, lineupId, playerId);

  if (error) return dispatch(handler(error));
  const normalizedInvoices = Array.isArray(invoices) ? invoices : (invoices?.data || invoices?.results || []);
  dispatch(revaActions.setRevaPlayerInvoices(normalizedInvoices));
};

export const registerPlayerInvoicesPayment = (lineupId, playerId, data) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.registerPayment"));
    const [error, result] = await revaService.registerPlayerInvoicesPayment(apiKey, lineupId, playerId, data);
    dispatch(setLoading.false("reva.registerPayment"));

    if (error) return dispatch(handler(error));
    
    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Pago de jugador registrado con éxito.", "info", 3000));
};

// Price List (Templates) Thunks
export const loadPriceList = (tournamentId) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey && !tournamentId) return;

    dispatch(setLoading.true("reva.loadPriceList"));
    const [error, priceList] = await revaService.getPriceList(apiKey, tournamentId);
    dispatch(setLoading.false("reva.loadPriceList"));

    if (error) return dispatch(handler(error));
    const normalizedPriceList = Array.isArray(priceList) ? priceList : (priceList?.data || []);
    dispatch(revaActions.setRevaPriceList({
        tournament_id: tournamentId,
        items: normalizedPriceList
    }));
};

export const createDebt = (fansburyId, debtData) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.createDebt"));
    const [error, result] = await revaService.createDebt(apiKey, fansburyId, debtData);
    dispatch(setLoading.false("reva.createDebt"));

    if (error) return dispatch(handler(error));

    dispatch(loadLineupFinancials(fansburyId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Deuda creada con éxito.", "info", 3000));
};

export const createPlayerDebt = (lineupId, playerId, debtData) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.createDebt"));
    const [error, result] = await revaService.createPlayerDebt(apiKey, lineupId, playerId, debtData);
    dispatch(setLoading.false("reva.createDebt"));

    if (error) return dispatch(handler(error));

    dispatch(loadPlayerFinancials(lineupId, playerId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Deuda de jugador creada con éxito.", "info", 3000));
};

export const applyPriceItem = (lineupId, templateIdOrSku, origin = null) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.applyPrice"));
    const [error, result] = await revaService.applyTemplateCharge(apiKey, lineupId, templateIdOrSku, origin);
    dispatch(setLoading.false("reva.applyPrice"));

    if (error) return dispatch(handler(error));

    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Cargo aplicado con éxito desde la lista de precios.", "info", 3500));
};

export const applyPlayerPriceItem = (lineupId, playerId, templateIdOrSku, origin = null) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.applyPrice"));
    const [error, result] = await revaService.applyPlayerTemplateCharge(apiKey, lineupId, playerId, templateIdOrSku, origin);
    dispatch(setLoading.false("reva.applyPrice"));

    if (error) return dispatch(handler(error));

    dispatch(loadPlayerFinancials(lineupId, playerId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Cargo de jugador aplicado con éxito.", "info", 3500));
};

export const applyAutomatedCharge = (tournamentId, lineupId, chargeType, origin = null) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    // 1. Fetch Price List silently
    const [errorPrice, priceList] = await revaService.getPriceList(apiKey, tournamentId);
    if (errorPrice) return; // Fail silently to not disrupt the main flow (like lineup creation)

    const normalizedPriceList = Array.isArray(priceList) ? priceList : (priceList?.data || []);
    
    // 2. Find template by internal type (e.g. 'tournament-entry-fee' or 'match-fee')
    // Fallback: check names if types are custom or legacy
    const template = normalizedPriceList.find(t => {
        if (chargeType === 'tournament-entry-fee') {
            return t.type === 'tournament-entry-fee' || t.name.toLowerCase().includes('inscripci');
        }
        if (chargeType === 'match-fee') {
            return t.type === 'match-fee' || t.name.toLowerCase().includes('partido');
        }
        return false;
    });

    if (!template || !template.sku) return; // Template not configured correctly on Reva

    // 3. Apply the charge
    const [errorApply, resultApply] = await revaService.applyTemplateCharge(apiKey, lineupId, template.sku, origin);
    
    if (errorApply) {
        // If it's a conflict explicitly generated by Reva (e.g. debt already generated), ignore it silently
        if (errorApply.response?.status !== 409) {
             console.error("Failed to automatically apply charge", errorApply);
        }
        return;
    }

    // 4. Refresh Lineup Data silently in background to update UI balances
    dispatch(loadLineupFinancials(lineupId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
};

export const processMatchIncidenceCharges = (matchId, incidences, tournamentId, matchDetails) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    // 1. Fetch Price List silently
    const [errorPrice, priceList] = await revaService.getPriceList(apiKey, tournamentId);
    if (errorPrice) return;
    const normalizedPriceList = Array.isArray(priceList) ? priceList : (priceList?.data || []);

    // 2. Group by player to handle double yellows
    const playerIncidences = {};
    for (const incidence of incidences) {
        if (!incidence.player) continue;
        if (!playerIncidences[incidence.player]) playerIncidences[incidence.player] = [];
        playerIncidences[incidence.player].push(incidence);
    }

    const mapCardTypeStr = (str) => {
        if (str === 'yellow-card-fee') return 'YellowCard';
        if (str === 'red-card-fee') return 'RedCard';
        if (str === 'blue-card-fee') return 'BlueCard';
        if (str === 'double-yellow-card-fee') return 'YellowCard';
        return '';
    };

    for (const playerId in playerIncidences) {
        let yellows = 0;
        let reds = 0;
        let blues = 0;
        const incList = playerIncidences[playerId];

        incList.forEach(inc => {
            if (inc.type === 'YellowCard') yellows++;
            if (inc.type === 'RedCard') reds++;
            if (inc.type === 'BlueCard') blues++;
        });

        const expectedChargeTypes = [];
        if (yellows >= 2) {
            expectedChargeTypes.push('double-yellow-card-fee');
            if (yellows > 2) {
                for (let i = 0; i < yellows - 2; i++) expectedChargeTypes.push('yellow-card-fee');
            }
        } else {
            for (let i = 0; i < yellows; i++) expectedChargeTypes.push('yellow-card-fee');
        }
        for (let i = 0; i < reds; i++) expectedChargeTypes.push('red-card-fee');
        for (let i = 0; i < blues; i++) expectedChargeTypes.push('blue-card-fee');

        for (const expectedChargeType of expectedChargeTypes) {
            // Locate the template in Reva
            const template = normalizedPriceList.find(t => 
                t.type === expectedChargeType || 
                (t.name.toLowerCase().includes(expectedChargeType.split('-')[0]) && t.name.toLowerCase().includes('tarjeta'))
            );

            if (!template || !template.sku) continue;

            // Determine player team hierarchy to fetch lineupId
            let lineupId = null;
            const localPlayer = matchDetails.localTeam?.checkedInPlayers?.find(p => p.id === playerId);
            const visitingPlayer = matchDetails.visitingTeam?.checkedInPlayers?.find(p => p.id === playerId);

            console.log('match details', matchDetails);
            if (localPlayer) lineupId =  matchDetails.localTeam.lineupId || matchDetails.localTeam.id;
            else if (visitingPlayer) lineupId = matchDetails.visitingTeam.lineupId || matchDetails.visitingTeam.id;

            if (!lineupId) continue; // Player not bound to a lineup

            // Dispatch background charge
            const representativeIncidence = incList.find(inc => inc.type === mapCardTypeStr(expectedChargeType)) || incList[0];
            const chargeOrigin = { id: representativeIncidence.id, type: 'incidence', name: representativeIncidence.type,  };
            
            console.log('lineupId', lineupId);
            console.log('playerId', playerId);
            console.log('template.sku', template.sku);
            console.log('chargeOrigin', chargeOrigin);

            const [errorApply] = await revaService.applyPlayerTemplateCharge(apiKey, lineupId, playerId, template.sku, chargeOrigin);

            if (errorApply && errorApply.response?.status !== 409) {
                console.error(`Failed to automatically apply charge for player ${playerId}`, errorApply);
            }
        }
    }

    // Refresh globally after batch processing
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
};

export const uploadRevaPayment = (externalEntityId, formData) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.uploadPayment"));
    const [error, result] = await revaService.uploadPayment(apiKey, externalEntityId, formData);
    dispatch(setLoading.false("reva.uploadPayment"));

    if (error) return dispatch(handler(error));

    dispatch(loadLineupFinancials(externalEntityId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Comprobante subido con éxito.", "info", 3000));
};

export const confirmRevaPayment = (externalEntityId) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.uploadPayment"));
    // Send empty object if no formData is provided
    const [error, result] = await revaService.uploadPayment(apiKey, externalEntityId, {});
    dispatch(setLoading.false("reva.uploadPayment"));

    if (error) return dispatch(handler(error));

    dispatch(loadLineupFinancials(externalEntityId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(loadSiloBalances());
    dispatch(alertActions.showFloatingAlert("Pago informado con éxito.", "info", 3000));
};

export const savePriceItem = (priceData) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.savePriceItem"));
    const [error, result] = await revaService.savePriceItem(apiKey, priceData);
    dispatch(setLoading.false("reva.savePriceItem"));

    if (error) return dispatch(handler(error));

    dispatch(loadPriceList(priceData.external_relationship_id || priceData.tournament_id));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(alertActions.showFloatingAlert("Plantilla guardada con éxito.", "info", 3000));
};

export const copyPriceList = (fromTournamentId, toTournamentId) => async (dispatch, getState) => {
    const { organizer, reva } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    // Get source items
    const sourceItems = reva.priceLists[fromTournamentId];
    if (!sourceItems || sourceItems.length === 0) {
        return dispatch(alertActions.showFloatingAlert("El torneo origen no tiene plantillas.", "error", 3000));
    }

    dispatch(setLoading.true("reva.copyPriceList"));
    
    // Save each item to target tournament
    for (const item of sourceItems) {
        await revaService.savePriceItem(apiKey, {
            external_relationship_id: toTournamentId,
            sku: item.sku,
            description: item.name,
            price: item.amount,
            type: item.type
        });
    }

    dispatch(setLoading.false("reva.copyPriceList"));
    dispatch(loadPriceList(toTournamentId));
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(alertActions.showFloatingAlert(`Se han copiado ${sourceItems.length} plantillas con éxito.`, "info", 3000));
};

export const deletePriceItem = (id, tournamentId) => async (dispatch, getState) => {
    const { organizer } = getState();
    const apiKey = organizer.single.revaApiKey;
    if (!apiKey) return;

    dispatch(setLoading.true("reva.deletePriceItem"));
    const [error, result] = await revaService.deletePriceItem(apiKey, id);
    dispatch(setLoading.false("reva.deletePriceItem"));

    if (error) return dispatch(handler(error));

    // We don't have tid here easily without passing it, but reva handles it or we refresh current state
    dispatch(loadDebtSummary());
    dispatch(loadIncomeSummary());
    dispatch(alertActions.showFloatingAlert("Plantilla eliminada con éxito.", "info", 3000));
};

export const batchSyncLineups = (lineups, explicitTournamentObj = null) => async (dispatch, getState) => {
  const { organizer, tournament: tournamentState } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey) return;

  const tournaments = tournamentState.all || [];

  dispatch(setLoading.true("reva.batchSync"));

  console.log('lineups from batchSyncLineups: ', lineups);
  
  const syncPromises = lineups.map(lineup => {
    const tournamentObj = explicitTournamentObj || tournaments.find(t => t.id === lineup.tournament_id);

    console.log('lineup to sync: ', lineup, tournamentObj);

    return revaService.syncLineup(apiKey, {
        external_entity_id: lineup.id,
        name: lineup.name || lineup.team?.name,
        external_relationship_id: lineup.tournament_id,
        external_display_name: tournamentObj?.name || "Tournament",
        contact_info: {
          email: lineup.email || organizer.single.email || "contacto@fansbury.com",
          phone: lineup.phone || organizer.single.phone || organizer.single.phoneNumber || "+595981000111"
        }
    });
  });

  const results = await Promise.all(syncPromises);
  dispatch(setLoading.false("reva.batchSync"));

  const errors = results.filter(([error]) => error);
  if (errors.length > 0) {
    dispatch(alertActions.showFloatingAlert(`Se sincronizaron algunas planillas, pero hubo ${errors.length} errores.`, "warning", 5000));
  } else {
    dispatch(alertActions.showFloatingAlert(`${lineups.length} planillas sincronizadas con éxito.`, "info", 3500));
  }

  dispatch(loadRevaAccounts()); 
  await dispatch(loadRevaLineups());
  dispatch(loadDebtSummary());
  dispatch(loadSiloBalances());
};

export const batchSyncPlayers = (organizerId, tournamentId, lineups) => async (dispatch, getState) => {
  const { organizer } = getState();
  const apiKey = organizer.single.revaApiKey;
  if (!apiKey || !lineups || lineups.length === 0) return;

  dispatch(setLoading.true("reva.batchSyncPlayers"));
  let allSyncPromises = [];
  let totalPlayers = 0;

  for (const lineup of lineups) {
    console.log('lineup to sync: ', lineup);

    // Load full lineup detail to reliably get its players array
    const [err, fullLineup] = await lineupService.loadOne(organizerId, tournamentId, lineup.id);
    if (!err && fullLineup && fullLineup.players) {
        const lineupName = lineup.name || lineup.team?.name || fullLineup.team?.name || "Lineup";
        fullLineup.players.forEach(player => {
            totalPlayers++;
            const mappedData = {
                player_id: player.id,
                player_name: `${player.firstName} ${player.lastName} - ${player.shirtNumber || ''}`.trim(),
                external_display_name: lineupName,
                contact_info: {
                    email: player.email || organizer.single.email || "contacto@fansbury.com",
                    phone: player.phone || organizer.single.phone || organizer.single.phoneNumber || "+595981000111"
                }
            };
            allSyncPromises.push(revaService.syncPlayer(apiKey, lineup.id, mappedData));
        });
    }
  }

  const results = await Promise.all(allSyncPromises);
  dispatch(setLoading.false("reva.batchSyncPlayers"));
  
  const errors = results.filter(([err]) => err);
  if (errors.length > 0) {
    dispatch(alertActions.showFloatingAlert(`Se sincronizaron los jugadores, pero hubo ${errors.length} errores.`, "warning", 5000));
  } else if (totalPlayers > 0) {
    dispatch(alertActions.showFloatingAlert(`${totalPlayers} jugadores sincronizados con éxito.`, "info", 3500));
  }
};
